module.exports = __webpack_public_path__ + "img/制御工学5_5_5.10b0f7b8.png";